/**
 * Custom, UI-owned error messages that override the message returned by the
 * backend for specific error codes. 
 *
 * Keyed first by language ('en' | 'fr'), then by error code.
 */
export const CustomAuthErrorMessages: Record<string, Record<string, string>> = {
  en: {
    '6010': 'The username or password you entered did not match our records. Please try again or select forgot username or forgot password. (6010)',
    '6011': 'Having trouble signing in? Try checking your username or resetting your password. You have <strong>2 more tries</strong> before your account is locked. (6011)',
    '6012': 'Having trouble signing in? Try checking your username or resetting your password. You have <strong>1 more try</strong> before your account is locked. (6012)',
    '6022': 'We\'re sorry. To protect your security, this account has been locked. <a href="https://www.canadapost-postescanada.ca/cpc/en/support.page">Please contact us for assistance</a>. (6022)'
  },
  fr: {
    '6010': "Le code d'utilisateur ou le mot de passe inscrit ne correspond pas à nos dossiers. Veuillez essayer de nouveau ou sélectionner J'ai oublié mon code d'utilisateur ou J'ai oublié mon mot de passe. (6010)",
    '6011': "Vous avez de la difficulté à ouvrir une session? Essayez de vérifier votre nom d'utilisateur ou de réinitialiser votre mot de passe. Il vous reste <strong>deux autres tentatives</strong> avant que votre compte soit verrouillé. (6011)",
    '6012': "Vous avez de la difficulté à ouvrir une session? Essayez de vérifier votre nom d'utilisateur ou de réinitialiser votre mot de passe. Il vous reste <strong>une autre tentative</strong> avant que votre compte soit verrouillé. (6012)",
    '6022': "Nous sommes désolés. Pour des raisons de sécurité, ce compte a été verrouillé. <a href=\"https://www.canadapost-postescanada.ca/scp/fr/soutien/bc/autres-produits-services/gestion-compte/compte-verrouille.page\">Veuillez communiquer avec nous pour obtenir de l'aide</a>. (6022)"
  }
};


/**
 * Returns a UI-owned custom message for the given error code in the current
 * locale, or `undefined` if no override is defined. Falls back to English
 * when the current locale is unknown.
 */
export function getCustomAuthErrorMessage(code: string, currentLang?: string): string | undefined {
  if (!code) {
    return undefined;
  }

  let lang: string;
  if (currentLang) {
    lang = currentLang;
  } else {
    try {
      lang = localStorage.getItem('locale') || document.documentElement.lang || 'en';
    }
    catch {
      lang = 'en';
    }
  }

  const messages = CustomAuthErrorMessages[lang] || CustomAuthErrorMessages['en'];
  return messages[code];
}
